import React from "react"

function IconWebhook({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="webhook"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-webhook"
      {...props}
    >
      <path
        d="M5.926 12.35a.655.655 0 0 1-.477.794 3.74 3.74 0 0 0 .907 7.365 3.738 3.738 0 0 0 3.732-3.533l.006-.205v-.654h5.471a2.12 2.12 0 1 1 0 1.31l-4.205-.002-.003.031a5.048 5.048 0 0 1-4.77 4.357l-.231.005a5.047 5.047 0 0 1-1.223-9.944.655.655 0 0 1 .793.477zm6.286-7.458.174.007a2.119 2.119 0 0 1 1.371 3.561l1.985 3.612.173-.066a5.03 5.03 0 0 1 1.38-.274l.286-.008a5.047 5.047 0 1 1-3.501 8.682.655.655 0 0 1 .908-.943 3.738 3.738 0 1 0 1.03-6.088l-.24.12-.574.317-2.594-4.72a2.119 2.119 0 1 1-.571-4.193l.173-.007zm5.369 11.07a.81.81 0 1 0 0 1.619.81.81 0 0 0 0-1.62zM12.212 6.2l-.122.01a.81.81 0 1 0 .382 1.567.494.494 0 0 1 .115-.086.657.657 0 0 1 .132-.055.732.732 0 0 0 .195-.222.81.81 0 0 0-.58-1.205l-.122-.009z"
        fill={color}
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
      <path
        d="M12.212 1.964a5.047 5.047 0 0 1 4.824 6.535.655.655 0 1 1-1.25-.386 3.738 3.738 0 1 0-5.667 1.995l.194.123.57.337-2.922 4.819a2.119 2.119 0 1 1-2.81-.358l.146-.093.147-.077a2.11 2.11 0 0 1 1.396-.15l2.26-3.727-.07-.054a5.04 5.04 0 0 1-1.858-3.66l-.006-.257a5.047 5.047 0 0 1 5.046-5.047zm-5.567 14.05a.809.809 0 0 0-.581.002l-.112.054-.092.061a.81.81 0 1 0 1.033.033.514.514 0 0 1-.135-.059l-.086-.062-.027-.029z"
        fill={color2 || color}
        style={{ height: height || fontSize }}
        originalclass="__danger"
      />
    </svg>
  )
}

export default IconWebhook
